import React from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import { xVerifyService } from 'services';

export default function Email(props) {
  const isEmailValid =
    props.state.verificationResult[props.id]?.status && !props.state.verifying
      ? xVerifyService.VALID_EMAIL_STATUSES.includes(
          props.state.verificationResult[props.id].status
        )
      : undefined;
  const isEmailInvalid =
    props.state.verificationResult[props.id]?.status && !props.state.verifying
      ? xVerifyService.INVALID_EMAIL_STATUSES.includes(
          props.state.verificationResult[props.id].status
        )
      : undefined;
  const invalidEmailMessage =
    xVerifyService.VALIDATION_MESSAGE[
      props.state.verificationResult[props.id]?.reason
    ] || 'You must provide a valid email address';
  //  console.log({ isEmailValid, isEmailInvalid });
  return (
    <>
      <Form.Group
        as={Row}
        controlId={props.id}
        className="mb-3 form-group-email"
      >
        <Form.Label column sm={6} required>
          {props.label}
        </Form.Label>

        <Form.Control
          type="email"
          required
          placeholder="Email address"
          pattern="^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
          isValid={isEmailValid}
          isInvalid={isEmailInvalid}
          onChange={props.onChange}
          onBlur={props.onBlur}
          value={props.state[props.id] ? props.state[props.id] : ''}
          data-hj-allow
        />
        {props.state.verifying && (
          <Form.Control.Feedback type="processing">
            Verification...
          </Form.Control.Feedback>
        )}
        <Form.Control.Feedback type="invalid">
          {invalidEmailMessage}
        </Form.Control.Feedback>
        {props.state.verifying && (
          <Spinner
            animation="border"
            variant="secondary"
            className="form-control-loader"
          />
        )}
      </Form.Group>
    </>
  );
}
